import { render, staticRenderFns } from "./IconLow.vue?vue&type=template&id=bb85e37a&"
import script from "./IconLow.vue?vue&type=script&lang=ts&"
export * from "./IconLow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports